/**
 * Utility functions for onboarding flow
 */

/**
 * Check if user should be redirected to onboarding
 * @param {Object} user - User object from Redux state
 * @param {Object} currentOrg - Current organization object from Redux state
 * @returns {boolean} - True if user should go through onboarding
 */
export const shouldRedirectToOnboarding = (user, currentOrg) => {
  if (!user || !currentOrg) return false;
  
  // Skip onboarding for marketing users
  if (user.isMarketing === true) {
    return false;
  }
  
  // Get user's current plan
  const userPlan = user.organizations && user.organizations[0] && user.organizations[0].plans && user.organizations[0].plans[0];
  if (!userPlan) return false;
  
  // Check if user is on free plan (priceMonthly === 0)
  const isOnFreePlan = userPlan.tier && userPlan.tier.priceMonthly === 0;
  
  // IMPORTANT: Only proceed if billing cycle data is fully loaded
  // This prevents false positives when data is still loading
  if (!currentOrg.currentBillingCycle) {
    return false;
  }
  
  // Check if billing cycle is still loading
  if (currentOrg.currentBillingCycle.loading === true) {
    return false;
  }
  
  // KEY FIX: Check if the billing cycle data has actually been loaded
  // The initial state has totalCalls: 0 but no startDate/endDate
  // After the API loads, we get real dates AND real totalCalls (which could also be 0)
  const hasRealBillingData = currentOrg.currentBillingCycle.startDate && currentOrg.currentBillingCycle.endDate;
  if (!hasRealBillingData) {
    return false; // Still using initial state, not real data
  }
  
  // Now we know totalCalls represents real data, not initial state
  const hasNeverMadeRequests = currentOrg.currentBillingCycle.totalCalls === 0;

  const userCreated = new Date(user.createdAt);
  const now = new Date();
  const twoMonthsAgo = new Date(now.setMonth(now.getMonth() - 2));
  if (userCreated < twoMonthsAgo) {
    return false;
  }
  
  // Redirect to onboarding if: on free plan AND has never made requests AND data is fully loaded
  return isOnFreePlan && hasNeverMadeRequests;
}; 